import { useIntl } from 'react-intl';
import { Routes, Route } from 'react-router-dom';
import RouteWrapper from '../common/RouteWrapper';
import ChangeEmailRoute from './ChangeEmailRoute';
import ConfirmChangeEmailRoute from './ConfirmChangeEmailRoute';

const ChangeEmailRoutes = () => {
  const intl = useIntl();

  return (
    <Routes>
      <Route
        index
        element={
          <RouteWrapper
            title={intl.formatMessage({
              id: 'changeEmail.seo.title',
              defaultMessage: 'ClearVPN | Change email',
            })}
          >
            <ChangeEmailRoute />
          </RouteWrapper>
        }
      />

      <Route
        path="confirm"
        element={
          <RouteWrapper
            title={intl.formatMessage({
              id: 'changeEmailConfirm.seo.title',
              defaultMessage: 'ClearVPN | Confirm change email',
            })}
          >
            <ConfirmChangeEmailRoute />
          </RouteWrapper>
        }
      />
    </Routes>
  );
};

export default ChangeEmailRoutes;
